import axios from './axios';

export default class plaidService {

    constructor() {
        this.axios = new axios();
    }

    createLinkToken = async (applicantId) => {
        let request = {
            ApplicantId: applicantId
        }

        return await this.axios.post("generate-plaid-link-token", request);
    }

    confirmAccountLinking = async (applicantId, userId) => {
        let request = {
            ApplicantId: applicantId,
            UserId: userId
        }

        return await this.axios.post("confirm-plaid-account-linking", request);
    }

    processDecline = async (applicantId) => {
        let request = {
            ApplicantId: applicantId
        }

        return await this.axios.post("process-decline", request);
    }
}